import { render, staticRenderFns } from "./projectExamine.vue?vue&type=template&id=5596a994&scoped=true"
import script from "./projectExamine.vue?vue&type=script&lang=js"
export * from "./projectExamine.vue?vue&type=script&lang=js"
import style0 from "./projectExamine.vue?vue&type=style&index=0&id=5596a994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5596a994",
  null
  
)

export default component.exports